import Vue from 'vue';
import axios from 'axios'

Vue.config.productionTip = false;

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;

Vue.prototype.$storeDossierBourse = {
    ListeAnnexesFirsi:[],
    TokenExtranet:null,
    Formulaire:{
        EstValidable:false,
        Programmes:[],
        ListeEcheanciers:[],
        ResultatVisible : false,
        ReadOnly : false,
        IdCandidatureBourse	:null,
        IdDossierBourse:null,
        IdEtudiant	:null,
        LabelEcole	:null,
        IdEcole : null,
        AnneeScolaire	:null,
        NumeroFiche	:null,
        NumDossier	:null,
        CandidatureBours	:null,
        Etat	:null,
        StatutBourse	:null,
        MontantTotalAttribue:null,
        Nom	:null,
        Programme	:null,
        NCNI	:null,
        Prenom	:null,
        Genre	:null,
        PremierDossier	:false,
        MontantDesFraisScolaire	: 0,
        BCS	:null,
        CVEC	:null,
        FraisDeCVEC	:0,
        BeneficiaireAutreBourse	:null,
        NomAutreBourse	:null,
        Iban	:null,
        BIC	:null,
        NumCompteMarocain:null,
        ChangerCompteBancaire:null,
        EmailPerso:null,
        EmailEcole:null,
        MobiliteInternationale	:null,
        NomEchangeMobiliteInternationale	:null,
        MontantBourseMobilite	:null,
        NomBourse	:null,
        MontantAutreBourse	:null,
        SouhaireBeneficierBourse	:null,
        Alternance	:null,
        Duree	:null,
        ContratProfessionnel	:null,
        Stage	:null,
        PriseEnChargeDesFraisDeScolarite	:null,
        DernierEtat	:null,
        SpecialiteFormation	:null,
        LienAnnexeBourse:null,
        Type:null,
        IbanModifiable:false,
        RegionMaroc:null,
        ProvinceMaroc:null,
        RibFr:null,
        RibMarocain:null,
        NoCompteExistant:null,
    },
    GetListe(token){
        return axios.create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: 'application/json',
                token:token
            }
        })
        .get("db/GetListe");
    },
    GetDossier(token, id){
        return axios.create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: 'application/json',
                token:token,
                id:id,
            }
        })
        .get("db/GetDossier");        
    },
    SaveDossier(token, valider){
        return axios.create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: 'application/json',
                token:token,
                valider:valider,
            }
        })
        .post("db/SaveDossier", this.Formulaire);        
    },
    SaveIban(token){
        return axios.create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: 'application/json',
                token:token,
            }
        })
        .post("db/SaveIban", this.Formulaire);        
    },
    ValiderDossier(token, IdDossier){
        return axios.create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: 'application/json',
                token:token,
                idDossier:IdDossier,
            }
        })
        .post("db/ValiderDossier"); 

    },
    ParseToFormulaire(formulaire){
        this.Formulaire.NoCompteExistant = formulaire.noCompteExistant;
        this.Formulaire.LienAnnexeBourse = formulaire.lienAnnexeBourse;
        this.Formulaire.Lydex = formulaire.lydex;
        this.Formulaire.EstValidable = formulaire.estValidable;
        this.Formulaire.ReadOnly = formulaire.readOnly;
        this.Formulaire.ResultatVisible = formulaire.resultatVisible;
        this.Formulaire.IdCandidaturBourse= formulaire.idCandidaturBourse;
        this.Formulaire.IdDossierBourse = formulaire.idDossierBourse;
        this.Formulaire.IdEtudiant= formulaire.idEtudiant;
        this.Formulaire.LabelEcole= formulaire.labelEcole;
        this.Formulaire.IdEcole = formulaire.idEcole;
        this.Formulaire.AnneeScolaire= formulaire.anneeScolaire;
        this.Formulaire.NumeroFiche= formulaire.numeroFiche;
        this.Formulaire.NumDossier= formulaire.numDossier;
        this.Formulaire.CandidatureBourse= formulaire.candidatureBourse;
        this.Formulaire.Etat= formulaire.etat;
        this.Formulaire.EtatDuDossier= formulaire.etatDuDossier;
        this.Formulaire.EtatDuDossierLang00 = formulaire.etatDuDossierLang00;
        this.Formulaire.StatutBourse= formulaire.statutBourse;
        this.Formulaire.MontantTotalAttribue = formulaire.montantTotalAttribue;
        this.Formulaire.Nom= formulaire.nom;
        this.Formulaire.NCNI = formulaire.ncni;
        this.Formulaire.Prenom= formulaire.prenom;
        this.Formulaire.Genre= formulaire.genre;
        this.Formulaire.PremierDossier= formulaire.premierDossier;
        this.Formulaire.MontantDesFraisScolaire= formulaire.montantDesFraisScolaire;
        this.Formulaire.BCS= formulaire.bcs;
        this.Formulaire.CVEC= formulaire.cvec;
        this.Formulaire.Type = formulaire.type;
        this.Formulaire.FraisDeCVEC= formulaire.fraisDeCVEC;
        this.Formulaire.BeneficiaireAutreBourse= formulaire.beneficiaireAutreBourse;
        this.Formulaire.NomAutreBourse= formulaire.nomAutreBourse;
        this.Formulaire.Iban= formulaire.iban;
        this.Formulaire.IbanExistant= formulaire.ibanExistant;
        this.Formulaire.BicExistant= formulaire.bicExistant;
        this.Formulaire.BIC= formulaire.bic;
        this.Formulaire.NumCompteMarocain= formulaire.numCompteMarocain;
        this.Formulaire.ChangerCompteBancaire = formulaire.changerCompteBancaire;
        this.Formulaire.MobiliteInternationale= formulaire.mobiliteInternationale;
        this.Formulaire.NomEchangeMobiliteInternationale= formulaire.nomEchangeMobiliteInternationale;
        this.Formulaire.MontantBourseMobilite= formulaire.montantBourseMobilite;
        this.Formulaire.NomBourse= formulaire.nomBourse;
        this.Formulaire.MontantAutreBourse= formulaire.montantAutreBourse;
        this.Formulaire.SouhaireBeneficierBourse= formulaire.souhaireBeneficierBourse;
        this.Formulaire.Duree= formulaire.duree;
        this.Formulaire.PriseEnChargeDesFraisDeScolarite= formulaire.priseEnChargeDesFraisDeScolarite;
        this.Formulaire.DernierEtat= formulaire.dernierEtat;
        this.Formulaire.SpecialiteFormation= formulaire.specialiteFormation;
        this.Formulaire.EmailEcole = formulaire.emailEcole;
        this.Formulaire.EmailPerso = formulaire.emailPerso;
        this.Formulaire.AdresseFrance = formulaire.adresseFrance;
        this.Formulaire.AdresseMaroc = formulaire.adresseMaroc;
        this.Formulaire.CpFrance = formulaire.cpFrance;
        this.Formulaire.CpMaroc = formulaire.cpMaroc;
        this.Formulaire.VilleFrance = formulaire.villeFrance;
        this.Formulaire.VilleMaroc = formulaire.villeMaroc;
        this.Formulaire.RegionFrance = formulaire.regionFrance;
        this.Formulaire.RegionMaroc = formulaire.regionMaroc;
        this.Formulaire.DepartementFrance = formulaire.departementFrance;
        this.Formulaire.ProvinceMaroc = formulaire.provinceMaroc;
        this.Formulaire.RibFr = formulaire.ribFr;
        this.Formulaire.RibMarocain = formulaire.ribMarocain;
        this.Formulaire.PaysFrance = formulaire.paysFrance
        this.Formulaire.PaysMaroc = formulaire.paysMaroc
        this.Formulaire.TelephoneFrance = formulaire.telephoneFrance;
        this.Formulaire.TelephoneMaroc = formulaire.telephoneMaroc;
        this.Formulaire.IbanModifiable = formulaire.ibanModifiable;
        this.Formulaire.ListeEcheanciers = [];
        this.Formulaire.Programmes= [];

        if(formulaire.programmes){
            formulaire.programmes.forEach(id=>{
                this.Formulaire.Programmes.push(id);
            });
        }
        if(formulaire.listeEcheanciers){
            formulaire.listeEcheanciers.forEach(echeance=>{
                this.Formulaire.ListeEcheanciers.push(echeance);
            })
        }
    },
    VerifierIban(iban){
        return axios.create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: 'application/json',
            }
        })
        .get("db/IsIban/"+iban);   
    },
    ElementToAnnexesFirsiDto(element){
        var annexe = {
            Editable:element.editable,
            Supprimer:false,
            IdCrypte:element.idCrypte,
            ObligatoireSoumettre:element.obligatoireSoumettre,
            LabelFormulaire:element.labelFormulaire ?? element.nomDocument?.lang00,
            AnneeScolaire:{
                Id : element.anneeScolaire?.id,
                Lang00 : element.anneeScolaire?.lang00,
            },
            ConformiteElectronique:{
                Id : element.conformiteElectronique?.id,
                Lang00 : element.conformiteElectronique?.lang00,
            },
            ConformitePhysique:{
                Id : element.conformitePhysique?.id,
                Lang00 : element.conformitePhysique?.lang00,
            },
            NatureDocument:{
                Id : element.natureDocument?.id,
                Lang00 : element.natureDocument?.lang00,
            },
            NomDocument:{
                Id : element.nomDocument?.id,
                Lang00 : element.nomDocument?.lang00,
            },
            NomFichier:element.nomFichier,
            DonneePieceJointe:element.donneePieceJointe,
            NonConformeElectronique:element.nonConformeElectronique,
            NonConformePhysique:element.nonConformePhysique,
            DossierBourseId:element.dossierBourseId,
            PpId:element.ppId,
            TemplateAnnexeFirsi:element.templateAnnexeFirsi,
            TypeDeDocument:{
                Id : element.typeDeDocument?.id,
                Lang00 : element.typeDeDocument?.lang00,
            },
            UrlFichier:element.urlFichier,
        };

        return annexe;
    },
    // Mappe la liste des annexes DTO en listeAnnexeFirsi
    MapperAnnexeFirsiDto(listeAnnexes){
        this.ListeAnnexesFirsi = [];
            listeAnnexes.forEach(annexe=>{
                var annexeDto = this.ElementToAnnexesFirsiDto(annexe);
                this.ListeAnnexesFirsi.push(annexeDto);
            })
    },
    DossierValidable(){
        return false;
    }
}